// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "startsAt",
                Decco.intToJson(v.startsAt)
              ],
              [
                "endsAt",
                Decco.intToJson(v.endsAt)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var startsAt = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startsAt"), null));
  if (startsAt.TAG === /* Ok */0) {
    var endsAt = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "endsAt"), null));
    if (endsAt.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                startsAt: startsAt._0,
                endsAt: endsAt._0
              }
            };
    }
    var e = endsAt._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".endsAt" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = startsAt._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".startsAt" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function mergeIfOverlap(r1, r2) {
  if (r1.endsAt > r2.startsAt && r2.startsAt >= r1.startsAt) {
    return {
            startsAt: r1.startsAt,
            endsAt: Math.max(r1.endsAt, r2.endsAt)
          };
  } else if (r2.endsAt > r1.startsAt && r1.startsAt >= r2.startsAt) {
    return {
            startsAt: r2.startsAt,
            endsAt: Math.max(r1.endsAt, r2.endsAt)
          };
  } else {
    return ;
  }
}

function length(param) {
  return param.endsAt - param.startsAt | 0;
}

var $$Range = {
  t_encode: t_encode,
  t_decode: t_decode,
  mergeIfOverlap: mergeIfOverlap,
  length: length
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "fullRange",
                t_encode(v.fullRange)
              ],
              [
                "rangeList",
                Decco.listToJson(t_encode, v.rangeList)
              ],
              [
                "additionalRange",
                Decco.optionToJson(t_encode, v.additionalRange)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fullRange = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fullRange"), null));
  if (fullRange.TAG === /* Ok */0) {
    var rangeList = Decco.listFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "rangeList"), null));
    if (rangeList.TAG === /* Ok */0) {
      var additionalRange = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "additionalRange"), null));
      if (additionalRange.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  fullRange: fullRange._0,
                  rangeList: rangeList._0,
                  additionalRange: additionalRange._0
                }
              };
      }
      var e = additionalRange._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".additionalRange" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = rangeList._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".rangeList" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = fullRange._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fullRange" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function maybeMergeWithRange(dataRecord, dataRecordRange) {
  return Belt_Option.map(mergeIfOverlap(dataRecord.fullRange, dataRecordRange), (function (fullRange) {
                return {
                        fullRange: fullRange,
                        rangeList: Belt_List.add(dataRecord.rangeList, dataRecordRange),
                        additionalRange: dataRecord.additionalRange
                      };
              }));
}

function maybeMergeWith(dataRecord, dataRecord$p) {
  return Belt_Option.map(mergeIfOverlap(dataRecord.fullRange, dataRecord$p.fullRange), (function (fullRange) {
                return {
                        fullRange: fullRange,
                        rangeList: Belt_List.concat(dataRecord.rangeList, dataRecord$p.rangeList),
                        additionalRange: dataRecord.additionalRange
                      };
              }));
}

function fromRange(dataRecordRange) {
  return {
          fullRange: dataRecordRange,
          rangeList: {
            hd: dataRecordRange,
            tl: /* [] */0
          },
          additionalRange: undefined
        };
}

function Make(Sequence) {
  var fromOccurrence = function (nodes, startsAt) {
    return {
            startsAt: startsAt,
            endsAt: startsAt + nodes.length | 0
          };
  };
  var $$Range = {
    t_encode: t_encode,
    t_decode: t_decode,
    mergeIfOverlap: mergeIfOverlap,
    length: length,
    fromOccurrence: fromOccurrence
  };
  var getNodes = function (sequence, param) {
    return Curry._2(Sequence.getRange, sequence, param.fullRange);
  };
  var maybeAdditionalRange = function (sequence, dataRegion) {
    var nodes = Curry._2(Sequence.getRange, sequence, dataRegion.fullRange);
    var nodesAfterEndsAt = Curry._2(Sequence.sliceToEnd, sequence, dataRegion.fullRange.endsAt);
    var maybeExtendToPosition = ArrayUtils$SmartcutsMacros.firstMatchi((function (node) {
            return Belt_Array.every(nodes, (function (nodeInSequence) {
                          return !Curry._3(Sequence.isNodeAncestorOf, sequence, nodeInSequence, node);
                        }));
          }), nodesAfterEndsAt);
    if (maybeExtendToPosition !== undefined) {
      var len = maybeExtendToPosition[1];
      if (len === 0) {
        return ;
      }
      var startsAt = dataRegion.fullRange.endsAt;
      var endsAt = startsAt + len | 0;
      return {
              startsAt: startsAt,
              endsAt: endsAt
            };
    }
    var startsAt$1 = dataRegion.fullRange.endsAt;
    var endsAt$1 = Curry._1(Sequence.length, sequence) + 1 | 0;
    return {
            startsAt: startsAt$1,
            endsAt: endsAt$1
          };
  };
  return {
          $$Range: $$Range,
          getNodes: getNodes,
          maybeAdditionalRange: maybeAdditionalRange
        };
}

exports.$$Range = $$Range;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.maybeMergeWithRange = maybeMergeWithRange;
exports.maybeMergeWith = maybeMergeWith;
exports.fromRange = fromRange;
exports.Make = Make;
/* ArrayUtils-SmartcutsMacros Not a pure module */
